/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable max-len */
import React from 'react';
import config from '../../../_config/config';

const numberOfLessons = config.hours.waxCourseTotalDuration / config.hours.waxCourseMeetingDuration;

const content = {
  name: 'kurs woskowy',
  description: <>
    Szkolenie to {config.hours.waxCourseTotalDuration} godzin zegarowych ({numberOfLessons} spotkań), spotkania odbywają się raz w tygodniu po 5h
    (obecnie są to środy 15:00-20:00).
    Zajęcia prowadzi <a href="/onas#mikolaj-piechota">Mikołaj Piechota</a>
    .
  </>,
  priceInfo: <>
    spotkania: 1x w tygodniu
    czas trwania szkolenia:
    {' '}
    {config.hours.waxCourseTotalDuration}
    h (
    {config.hours.waxCourseMeetingDuration}
    h x {numberOfLessons} spotkań)
    <br />
    cena:
    {' '}
    {config.prices.waxCourse}
    {' '}
    zł
  </>,
  curriculumLabel: <>Zagadnienia i projekty podczas kursu</>,
  curriculumDescription: (
    <ul>
      <li>Omówienie rodzajów wosków, narzędzi oraz urządzeń używanych przy pracy z woskiem</li>
      <li>Praca z woskiem: proste zadania polegające na cięciu, piłowaniu, modelowaniu i rzeźbieniu</li>
      <li>Przygotowanie prostych form obrączek z tuby woskowej o różnych kształtach i przekrojach: wypukły, wklęsły, prosty, trójkątny</li>
      <li>Wykonanie wisiorka/zawieszki o geometrycznym lub nieregularnym kształcie</li>
      <li>Przygotowanie sygnetu z tuby woskowej o wybranym kształcie (koło, owal, kwadrat, prostokąt itp.)</li>
      <li>Wykonanie pierścionka lub wisiorka z prostymi oprawami kamieni</li>
      <li>Nadawanie różnych faktur powierzchni wosku i prostych zdobień</li>
      <li>Obróbka wybranych odlewów (usługa odlewania oraz materiał są dodatkowo płatne, zależnie od wielkości i wagi obiektu, który wykonasz w czasie zajęć)</li>
    </ul>
  ),
};

export default content;
